import { NavExternalLink } from "types/CMS/KontentAI/content-types/external_link";
import { NavInternalLink } from "types/CMS/KontentAI/content-types/internal_link";
import { linkResolver } from "./link";
import { ctas } from "types/CMS/Unum/ctas";
import { createResolver } from "./Factories/ResolverFactory";

export const CtaResolver = createResolver({
  resolve: (ctas: (NavInternalLink | NavExternalLink)[]): ctas => {
    return ctas
      .map((cta) => {
        return linkResolver.resolve(cta).result;
      })
      .filter((cta) => cta !== undefined) as ctas;
  },
});
